export const ReservationStatus = {
    READY_FOR_PICKUP: "ReadyForPickup",
    CANCELLED: "Cancelled",
    NEW: "New",
};
